module.exports = __webpack_public_path__ + "img/228.e554ce1c.jpg";